export default __webpack_public_path__ + "static/media/Huisman.9fb08a15.png";